<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Distributor Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-3 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-3 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedDistributor.d_id ? 'shift-up' : ''"
                >{{ $t("select") }} Distributor</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="distributorsList"
                v-model="selectedDistributor"
                :searchable="true"
                label="d_company_name"
                track-by="d_id"
                placeholder="Select Distributor"
                :allowEmpty="false"
                :showLabels="false"
                @input="fetchDistributorMovies()"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-3 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedMovie.movie_id ? 'shift-up' : ''"
                >{{ $t("select") }} Movie</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="MovieList"
                v-model="selectedMovie"
                :searchable="true"
                label="movie_title"
                track-by="md_id"
                placeholder="Select Distributor"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-1 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getDistributorReport('N', 'N')"
              style="min-width: 85px !important;"
            >
              {{ $t("fetch") }}
              <!-- {{ $t("report") }} -->
            </button>
          </div>
          <!-- <div class="col-lg-8 col-xl-2 align-self-center mb-3">
            <div class="input_material">
              <b-form-input
                type="search"
                @input="onSearch"
                v-model="searchText"
                placeholder="Search Bill No"
              ></b-form-input>
            </div>
          </div> -->

          <div
            v-if="distributorRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getDistributorReport('Y', 'N')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getDistributorReport('N', 'Y')"
              title="Download as PDF"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
            <!-- <a
              target="_blank"
              @click="getDistributorReport('N', 'N', 'Y')"
              title="Download as PDF"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a> -->
          </div>
        </div>
      </div>
      <div
        style="overflow-x:scroll;width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Show Date</th>
            <th>Screen</th>
            <th>Show Time</th>
            <th>Ticket Type</th>
            <th>Average Ticket Price</th>
            <th>Admits</th>
            <th v-if="isComp">Comps</th>
            <!-- <th>Gross Amount</th>
            <th>Offers</th> -->
            <th>GRS Amount</th>
            <!-- <th>VAT%</th> -->
            <th>VAT Amount</th>
            <!-- <th>Before M-Tax</th> -->
            <!-- <th>M-Tax%</th> -->
            <th>M-Tax Amount</th>
            <th>Net Amount</th>
          </thead>
          <tbody v-if="distributorRecords.length > 0">
            <template v-for="(distObj, distIndex) in distributorRecords">
              <tr :key="distIndex + 'distObj'">
                <td :colspan="isComp ? 10 + 1 : 10" class="text-left movie_bg">
                  {{ distObj.movie_name }}
                </td>
              </tr>
              <template v-for="(movieObj, movieIndex) in distObj.movieData">
                <tr :key="movieIndex + 'movieObj'">
                  <td :rowspan="movieObj.showDateRowspan + 1" class="text-left">
                    {{ movieObj.t_show_date }}
                  </td>
                </tr>
                <template
                  v-for="(showDateObj, showDateIndex) in movieObj.showDateData"
                >
                  <tr :key="showDateIndex + 'showDateObj'">
                    <td
                      :rowspan="showDateObj.screenRowspan + 1"
                      class="text-left"
                    >
                      {{ showDateObj.screen_name }}
                    </td>
                  </tr>
                  <template
                    v-for="(screenObj, screenIndex) in showDateObj.screenData"
                  >
                    <tr :key="screenIndex + 'screenObj'">
                      <td
                        :rowspan="screenObj.showTimeRowspan + 1 + 1"
                        class="text-left"
                      >
                        {{ screenObj.t_show_time }}
                      </td>
                    </tr>
                    <template
                      v-for="(showTimeObj,
                      showTimeIndex) in screenObj.showTimeData"
                    >
                      <tr :key="showTimeIndex + 'showTimeObj'">
                        <td class="text-left">
                          {{ showTimeObj.ticket_type_name }}
                        </td>
                        <td class="text-right">
                          {{
                            currFormat(
                              +parseFloat(
                                showTimeObj.bo_amount / showTimeObj.ticketsSold
                              )
                            )
                          }}
                        </td>
                        <td class="text-right">
                          {{ showTimeObj.ticketsSold || 0}}
                        </td>
                        <td class="text-right" v-if="isComp">
                          {{ showTimeObj.m_vat_free_ticket }}
                        </td>
                        <!-- commeted this on requirement basis -->
                        <!-- <td class="text-right">
                          {{ currFormat(showTimeObj.gross_amount) }}
                        </td>
                        <td class="text-right">
                          {{ currFormat(showTimeObj.offers) }}
                        </td> -->
                        <!-- commeted this on requirement basis -->
                        <td class="text-right">
                          {{ currFormat(showTimeObj.bo_amount) }}
                        </td>
                        <!-- <td class="text-right">{{
                          currFormat(showTimeObj.vat_percentage)
                        }}</td> -->
                        <td class="text-right">
                          {{ currFormat(showTimeObj.vat) }}
                        </td>
                        <!-- <td class="text-right">{{
                          currFormat(showTimeObj.before_m_tax)
                        }}</td> -->
                        <!-- <td class="text-right">{{
                          currFormat(showTimeObj.m_tax_percentage)
                        }}</td> -->
                        <td class="text-right">
                          {{ currFormat(showTimeObj.m_tax) }}
                        </td>
                        <td class="text-right">
                          {{
                            currFormat(
                              showTimeObj.bo_amount -
                                showTimeObj.vat -
                                showTimeObj.m_tax
                            )
                          }}
                        </td>
                      </tr>
                    </template>
                    <tr
                      :key="'showTimeTotal' + movieObj + showTimeObj"
                      class="movie_bg font-weight-bold"
                    >
                      <td colspan="2" class="text-left">Total</td>
                      <td class="text-right">
                        {{
                          (
                            screenObj.showTimeData.reduce(
                              (acc, { ticketsSold }) => {
                                return acc + +parseFloat(ticketsSold);
                              },
                              0
                            )
                          )
                        }}
                      </td>
                      <td class="text-right" v-if="isComp">
                        {{
                          (
                            screenObj.showTimeData.reduce(
                              (acc, { m_vat_free_ticket }) => {
                                return acc + +parseFloat(m_vat_free_ticket);
                              },
                              0
                            )
                          )
                        }}
                      </td>
                      <!-- commeted this on requirement basis -->
                      <!-- <td class="text-right">
                        {{
                          currFormat(
                            screenObj.showTimeData.reduce(
                              (acc, { gross_amount }) => {
                                return acc + +parseFloat(gross_amount);
                              },
                              0
                            )
                          )
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          currFormat(
                            screenObj.showTimeData.reduce((acc, { offers }) => {
                              return acc + +parseFloat(offers);
                            }, 0)
                          )
                        }}
                      </td> -->
                      <!-- commeted this on requirement basis -->

                      <td class="text-right">
                        {{
                          currFormat(
                            screenObj.showTimeData.reduce(
                              (acc, { bo_amount }) => {
                                return acc + +parseFloat(bo_amount);
                              },
                              0
                            )
                          )
                        }}
                      </td>
                      <!-- <td class="text-right"></td> -->
                      <td class="text-right">
                        {{
                          currFormat(
                            screenObj.showTimeData.reduce((acc, { vat }) => {
                              return acc + +parseFloat(vat);
                            }, 0)
                          )
                        }}
                      </td>

                      <!-- <td class="text-right">
                        {{
                          currFormat(
                            screenObj.showTimeData.reduce(
                              (acc, { before_m_tax }) => {
                                return acc + +parseFloat(before_m_tax);
                              },
                              0
                            )
                          )
                        }}
                      </td> -->
                      <!-- <td class="text-right"></td> -->
                      <td class="text-right">
                        {{
                          currFormat(
                            screenObj.showTimeData.reduce((acc, { m_tax }) => {
                              return acc + +parseFloat(m_tax);
                            }, 0)
                          )
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          currFormat(
                            screenObj.showTimeData.reduce(
                              (acc, { bo_amount, m_tax, vat }) => {
                                return (
                                  acc + +parseFloat(bo_amount - vat - m_tax)
                                );
                              },
                              0
                            )
                          )
                        }}
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
              <template v-for="(movieTotalObj, movieTotalIndex) in movieTotal">
                <tr
                  v-if="movieTotalObj.movie_id == distObj.movie_id"
                  :key="'movieTotalIndex' + movieTotalIndex"
                  class="movie_bg font-weight-bold"
                >
                  <td colspan="5" class="text-left">Movie Total</td>
                  <td class="text-right">
                    {{ currFormat(movieTotalObj.ticketsSold_total) }}
                  </td>
                  <td class="text-right" v-if="isComp">
                    {{ currFormat(movieTotalObj.m_vat_free_ticket_total || 0) }}
                  </td>
                  <!-- <td class="text-right">
                    {{ currFormat(movieTotalObj.gross_amount_total) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(movieTotalObj.offers_total) }}
                  </td> -->
                  <td class="text-right">
                    {{ currFormat(movieTotalObj.bo_amount_total) }}
                  </td>
                  <!-- <td class="text-right"></td> -->
                  <td class="text-right">
                    {{ currFormat(movieTotalObj.vat_total) }}
                  </td>
                  <!-- <td class="text-right">
                    {{ currFormat(movieTotalObj.before_m_tax_total) }}
                  </td>
                  <td class="text-right"></td> -->
                  <td class="text-right">
                    {{ currFormat(movieTotalObj.m_tax_total) }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        movieTotalObj.bo_amount_total -
                          movieTotalObj.vat_total -
                          movieTotalObj.m_tax_total
                      )
                    }}
                  </td>
                </tr>
              </template>
            </template>
            <tr class="bg-lightgrey font-weight-bold">
              <td colspan="5" class="text-left">Grand Total</td>
              <td class="text-right">
                {{ currFormat(grandTotal.ticketsSold_total) }}
              </td>
              <td class="text-right" v-if="isComp">
                {{ currFormat(grandTotal.m_vat_free_ticket_total) }}
              </td>
              <!-- <td class="text-right">
                {{ currFormat(grandTotal.gross_amount_total) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.offers_total) }}
              </td> -->
              <td class="text-right">
                {{ currFormat(grandTotal.bo_amount_total) }}
              </td>
              <!-- <td class="text-right"></td> -->
              <td class="text-right">{{ currFormat(grandTotal.vat_total) }}</td>
              <!-- <td class="text-right">
                {{ currFormat(grandTotal.before_m_tax_total) }}
              </td>
              <td class="text-right"></td> -->
              <td class="text-right">
                {{ currFormat(grandTotal.m_tax_total) }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    grandTotal.bo_amount_total -
                      grandTotal.vat_total -
                      grandTotal.m_tax_total
                  )
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td :colspan="isComp ? 12 + 1 : 12">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService-v2";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import { authenticationService } from "@/services/AuthenticationService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        distributorsList: [],
        movieTotal: [],
        selectedDistributor: {
          d_company_name: "",
          d_id: "",
        },
        selectedMovie: {
          movie_title: "",
          movie_id: "",
          md_id: "",
        },
        MovieList: [],
        distributorRecords: [],
        excelFilePath: "",
        nepalMonth: {},
        grandTotal: {},
        disabledDates: {
          from: "",
        },
        searchText: "",
        isComp: "",
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.fromDate = new Date();
      Promise.all([
        this.getCinemaList(),
        this.getDistributorsList(),
      ]).then(() => {});
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
    },
    watch: {
      // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      //   if (CinemaObj) {
      //     this.onSelectCinema(CinemaObj);
      //   }
      // },
      excelFilePath(value) {
        this.excelFilePath = value;
      },
      fromDate: function(value) {
        this.disabledDates.from = new Date(
          moment(this.fromDate).format("YYYY"),
          parseFloat(moment(this.fromDate).format("MM")),
          1
        );
        this.toDate = moment(this.toDate).isAfter(value, "months")
          ? moment(this.fromDate)
              .endOf("month")
              .format("YYYY-MM-DD")
          : this.toDate;
      },
    },
    mounted() {},
    methods: {
      onChangeDate: function(e, type){
        if(type ==  'from'){
          this.toDate = new Date(e);
        }
      },
      moment,
      getCinemaList: function() {
        MasterService.GetCinemasByRoles()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
      },
      getDistributorsList: function() {
        let body = {
          tableName: "ms_distributors",
          d_is_active: "Y",
        };
        MasterService.GetActiveList(body)
          .then((response) => {
            const { data } = response;

            if (data && data.status && data.Records.length > 0) {
              this.distributorsList = data.Records;
            } else {
              this.$toasted.show("Failed to fetch distributor names");
            }
          })
          .catch((error) =>
            Vue.toasted.show(
              "Catch Error on MasterStore fetchDistributorsList",
              error
            )
          );
      },
      fetchDistributorMovies() {
        if (!this.dropDown.selectedCinemaId) {
          this.$toasted.show("Please Select Cinema");
          this.selectedDistributor = [];
          this.$forceUpdate();
        } else {
          this.MovieList = [];
          this.selectedMovie.movie_id = "";
          this.selectedMovie.movie_title = "";
          this.selectedMovie.md_id = "";
          let payload = {
            fromDate: this.fromDate,
            toDate: this.toDate,
            cinema_id: this.dropDown.selectedCinemaId,
            cinema_name: this.dropDown.selectedCinemaName,
            d_id: this.selectedDistributor.d_id,
            d_company_name: this.selectedDistributor.d_company_name,
            country_id: authenticationService.get("BRGLOPCO"),
            filter_with_key: "ss_actual_start_date",
          };
          ReportsService.getDistributorMovieFormatV2(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status && data.Records) {
                this.MovieList = data.Records;
              } else
                this.$toasted.show(
                  data.message || "Opps! Something went wrong"
                );
            })
            .catch((error) => {
              this.$toasted.show(
                "Catch Error on ReportStore fetchDistributorMovies",
                error
              );
            });
        }
      },
      getDistributorReport(isExcel, isPdf, isPdf2 = "N") {
        if (isExcel == "N" || isPdf == "N" || isPdf2 == "N") {
          this.distributorRecords = [];
        }
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          d_name: this.selectedDistributor.d_company_name,
          d_id: this.selectedDistributor.d_id,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          movie_id: this.selectedMovie.md_id,
          isExcel,
          isPdf,
          isPdf2,
        };
        ReportsService.getDistributorReportStar(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.distributorRecords = [...data.Records];
              this.isComp = data.checkShowComplimentaryColumn;
              this.grandTotal = { ...data.grandTotal };
              this.movieTotal = [...data.movieTotal];
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              if (isPdf2 == "Y" && data.pdf2Path) {
                window.open(data.pdf2Path, "_blank");
              }
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
</script>

<style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }

  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
  }
  .swc-report-table td {
    white-space: nowrap;
  }
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
  }
  .swc_table_header th {
    border: 1px solid black !important;
  }
  .no_border {
    border: 0px !important;
  }
  .movie_bg {
    background-color: #eaeaea;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/distributorReportStar.vue